import { appPaths } from "../../../shared/routing/appPaths";

export function proposalPath(source: string) {
  const [thread = "", entry = ""] = source.split("#");
  const [number, revision] = entry.split("/r");
  const path = appPaths.extraction(thread, Number(number));
  return revision === undefined ? path : `${path}?revision=${encodeURIComponent(revision)}`;
}
